








































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyForm from "@/mixins/form";
import SelectOrders from "@/components/selectorders.vue";

@Component({
  components: {
    SelectOrders
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() itemId!: number;

  selectOrderModalVisible = false;

  refIds: string[] = [];

  showSelectOrderModal() {
    this.selectOrderModalVisible = true;
  }

  hideSelectOrderModal() {
    this.selectOrderModalVisible = false;
  }

  handleSelectOrder(e: any) {
    // console.log(e);

    this.refIds = e;

    this.hideSelectOrderModal();
  }

  getTotal(v:any){
    const t=this.renderFormValue(v, 0)
    return t/100
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("stadium/settlementItemsDetailDetail", {
      stadium_id: this.stadiumId,
      id: this.editId
    });
    if (res && res.Data) {
      this.formData = res.Data;
      if (res.Data.ref_ids) {
        this.refIds = res.Data.ref_ids.split(",");
      }
    }

    this.spinLoading = false;
  }

  getValue(obj: any, path: any) {
    let result = _.get(obj, path);
    // console.log(result)
    if (_.isUndefined(result) || result === "0" || result == null) {
      result = null;
    } else {
      result = moment(result*1000);
    }
    return result;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("stadium/settlementItemsDetailEdit", {
              stadium_id: this.stadiumId,
              item_id: this.itemId,
              id: this.editId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
